import React from 'react';
import { styled } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useHistory } from 'react-router';
import { Colors } from 'library';
import { Avatar, IconButton, Link, Row } from 'library/ui';

interface IProvider {
    user: {
        id: number;
    };
}

interface IProps {
    providerIdObject: IProvider;
    providerName: string;
    isMobile?: boolean;
    providerImage?: string;
}

export const ThreadHeader = ({ providerIdObject, providerName, isMobile, providerImage }: IProps) => {
    const history = useHistory();

    return (
        <Header gap="sm" align="center">
            {isMobile && <IconButton icon={ArrowBack} onClick={() => history.push('/messages')} />}
            <Avatar name={providerName} size={40} imageUrl={providerImage} />
            <Link onClick={() => history.push(`/provider/${providerIdObject.user.id}`)} weight="semibold">
                {providerName}
            </Link>
        </Header>
    );
};

const Header = styled(Row)({
    padding: '12px 16px',
    borderBottom: `1px solid ${Colors.border}`,
});
